<mat-card>
  
<div *ngIf="appType$ | async; let app_type">
<div *ngIf="user$ | async; let auser">
<div *ngIf="userTokens$ | async; let user_tokens">
<mat-card>
  <mat-card-title><span i18n>Group</span>
<div *ngIf="auser.customClaims.groups == 'admin'; then thenBlock else elseBlock"></div>
<ng-template #thenBlock>
  <!-- admin -->
  : {{getGroup()}} 
</ng-template>
<ng-template #elseBlock>
  <!-- Not admin -->
  : {{auser.customClaims.groups}}
</ng-template>
</mat-card-title>
</mat-card>

<!-- class="list-group" -->

  <div *ngIf="settingsGroup$ | async as settingsGroup; else indicator">
    <div *ngIf="appType$ | async; let app_type">
    <mat-list>
      <mat-card>
      <mat-list-item *ngFor="let user of settingsGroup">
        <p *ngIf="app_type == 'cartrack' && (user.Options == '2' || user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine><span i18n>Name : </span>{{user.Name}}</p>
        <p *ngIf="app_type == 'carpool'" matLine><span i18n>Name</span> : {{user.Name}}</p>
        
        <p *ngIf="(user.CurrentUser == user.UserId || auser.customClaims.groups == 'admin') && (user.Options == '1')" matLine><span i18n>Short name : </span>{{user.ShortName}}  
          <button mat-raised-button style="float: right;" color="primary" (click)="openEditDialog(user)"><span i18n>Edit</span></button>
        </p>
        <p *ngIf="user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin'" matLine><span i18n>User-ID</span> : {{user.UserId}}</p>
        <p *ngIf="user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin'" matLine><span i18n>Email</span> : {{user.Email}}</p>
        
        <div *ngIf="(user.CurrentUser == user.UserId || auser.customClaims.groups == 'admin') && (user.Options == '1')"matLine>
          <div layout="row" layout-align="center center" *ngFor="let item of user_tokens | keyvalue">
            <!-- Key: <b>{{item.key}}</b> and Value: <b>{{item.value}}</b> -->
            <p *ngIf="item.key == user.UserId" matLine><span i18n>User Token</span> : {{item.value}} 
              <button style="float: right;" mat-raised-button color="primary" (click)="newToken(user)"><span i18n>New Token</span></button>
            </p>
            <p *ngIf="item.key == user.UserId" matLine>
              <button style="float: right;" mat-raised-button color="primary" (click)="emailToken(user)"><span i18n>Email
                  Token</span></button>
            </p>

          </div>
        </div>  
        <div *ngIf="(auser.customClaims.groups == 'admin') && (user.Options == '2')"matLine>
          <button mat-raised-button style="float: right;" color="primary" (click)="openEditDialog(user)"><span i18n>Edit</span></button>
        </div>  
        <div *ngIf="(user.Options == '2') || (app_type == 'carpool')"matLine>
          <p *ngIf="app_type == 'cartrack' && (auser.customClaims.groups == 'admin')" matLine><span i18n>Car-ID</span> : {{user.CarId}}</p>
          <p *ngIf="app_type == 'cartrack' && (auser.customClaims.groups == 'admin')" matLine><span i18n>Battery change date</span> : {{user.BatteryChangeDate}}</p>
          <p *ngIf="app_type == 'carpool' && (user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine><span i18n>Car-ID</span> : {{user.CarId}}</p>  
          <p *ngIf="app_type == 'carpool' && (user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine>
            <span i18n>Battery change date</span> : {{user.BatteryChangeDate}}</p>
          <p *ngIf="app_type == 'cartrack' && (user.Options == '2' || auser.customClaims.groups == 'admin')" matLine><span i18n>Car model</span> : {{user.CarModel}}</p>

          <p *ngIf="app_type == 'carpool'" matLine><span i18n>Car model</span> : {{user.CarModel}}</p>
          <p *ngIf="app_type == 'cartrack' && (user.Options == '2' || auser.customClaims.groups == 'admin')" matLine><span i18n>Licenseplate</span> : {{user.LicensePlate}}</p>
            <div *ngIf="app_type == 'carpool'  && (user.CurrentUser == user.UserId || auser.customClaims.groups == 'admin')" matLine>
              <button mat-raised-button style="float: right;" color="primary" (click)="openAddTripDialog(user)"><span i18n>Add
                  Trip</span></button>
            </div>
            <div *ngIf="app_type == 'cartrack' && (user.Options == '2' || auser.customClaims.groups == 'admin')" matLine>
              <button mat-raised-button style="float: right;" color="primary" (click)="openAddTripDialog(user)"><span i18n>Add
                  Trip</span></button>
            </div>

          <p *ngIf="app_type == 'carpool'" matLine><span i18n>Licenseplate</span> : {{user.LicensePlate}}</p>
          <p *ngIf="app_type == 'cartrack' && (auser.customClaims.groups == 'admin')" matLine><span i18n>Sensor code</span> : {{user.UuidMajor}}</p>
          <p *ngIf="app_type == 'carpool' && (user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine><span i18n>Sensor code</span> : {{user.UuidMajor}}</p>
          <p *ngIf="app_type == 'cartrack' && (auser.customClaims.groups == 'admin')" matLine><span i18n>Sensor battery status</span> : {{user.BattStatus}}</p>
          <p *ngIf="app_type == 'carpool' && (user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine><span i18n>Battery</span> : {{user.BattStatus}}</p>
        </div>  

        <p *ngIf="app_type == 'cartrack' && (user.Options == '2' || user.CurrentUser == user.UserId  || auser.customClaims.groups == 'admin')" matLine><span i18n>Type</span> : {{ convertOptionVal(user.Options)}}</p>
        <p *ngIf="app_type == 'carpool'" matLine><span i18n>Type</span> : {{convertOptionVal(user.Options)}}</p>

       <mat-divider></mat-divider> 
      </mat-list-item>
      </mat-card>
    </mat-list> 
       
  </div>
  <ng-template #indicator>
    <loading-indicator>Loading...</loading-indicator>
  </ng-template> 
</div>
</div>
</div>
</div>
</mat-card>
<mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
  <mat-progress-spinner diameter="300"
    color="primary" 
    mode="indeterminate">
  </mat-progress-spinner>
</mat-card>



